<template>
    <div id="profile-view" class="view form-view">
        <h2>User Profile</h2>

        <v-layout row>
            <profile-settings
                :form="formSettings"
                :handler="saveSettings"
            ></profile-settings>

            <profile-password
                :form="formPassword"
                :handler="changePassword"
            ></profile-password>
        </v-layout>
    </div>
</template>

<script>
import ProfilePassword from '@/views/Profile/components/ProfilePassword'
import AccountApi from '@/api/AccountApi'
import toast from '@/plugins/izitoast'
import ProfileSettings from '@/views/Profile/components/ProfileSettings'
import { mapActions } from 'vuex'

const accountApi = new AccountApi()

const body = document.body

export default {
    name: 'Profile',
    data () {
        return {
            formPassword: {
                currentPassword: null,
                newPassword: null
            },
            formSettings: {
                language: null,
                speedUnit: null
            }
        }
    },
    mounted () {
        body.classList.add('profile-view')

        this.getUserSettings()
    },
    beforeDestroy () {
        body.classList.remove('profile-view')
    },
    components: {
        ProfileSettings,
        ProfilePassword
    },
    methods: {
        async getUserSettings () {
            const response = await accountApi.getUserSettings()

            if (!response.isSuccess) {
                return
            }

            this.formSettings = {
                language: response.payload.language,
                speedUnit: response.payload.speedUnit
            }
            this.setUserSettings(response.payload)
        },
        async changePassword (form) {
            const response = await accountApi.changePassword({
                currentPassword: form.currentPassword,
                newPassword: form.newPassword
            })

            if (!response.isSuccess) {
                return
            }

            toast.success('Password has been changed successfully.')
            this.formPassword = {
                currentPassword: null,
                newPassword: null
            }
        },
        async saveSettings (form) {
            const response = await accountApi.changeSettings({
                speedUnit: form.speedUnit,
                language: form.language
            })

            if (!response.isSuccess) {
                return
            }
            toast.success('Settings has been updated successfully.')
            this.getUserSettings()
        },
        ...mapActions('authModule', [
            'setUserSettings'
        ])
    }
}
</script>

<style scoped>

</style>
